import React from 'react';
import type { CustomFieldDefinition } from '@hrms/shared';
import { api } from '../../../lib/api';
import { humanize } from '../../../lib/date';
import { CrudList } from '../components/CrudList';
import { Badge, Screen, Text } from '../../../ui';

/** Extra employee attributes shown on the employee form's Custom fields tab. */
export function CustomFieldsScreen() {
  return (
    <Screen testID="custom-fields">
      <CrudList<CustomFieldDefinition>
        title="Custom fields"
        singular="Custom field"
        description="Extra employee attributes shown on the employee form's Custom fields tab."
        resource={api.customFields}
        queryKey={['custom-fields']}
        columns={[
          { key: 'sort_order', title: '#', width: 50, flex: 0 },
          { key: 'label', title: 'Label', width: 160, flex: 2 },
          { key: 'key', title: 'Key', width: 150, render: (r) => <Text variant="mono">{r.key}</Text>, sortValue: (r) => r.key },
          { key: 'type', title: 'Type', width: 90, render: (r) => humanize(r.type), sortValue: (r) => r.type },
          { key: 'options', title: 'Options', width: 160, sortable: false, render: (r) => r.options?.join(', ') || '—' },
          { key: 'is_required', title: 'Required', width: 100, sortValue: (r) => (r.is_required ? 1 : 0), render: (r) => (r.is_required ? <Badge tone="warning">Required</Badge> : '—') },
        ]}
        fields={[
          { key: 'label', label: 'Label', required: true },
          { key: 'key', label: 'Key', required: true, hint: 'snake_case, e.g. t_shirt_size', createOnly: true },
          { key: 'type', label: 'Type', type: 'select', required: true, default: 'text', options: ['text', 'number', 'date', 'select', 'boolean'].map((t) => ({ value: t, label: humanize(t) })) },
          { key: 'options', label: 'Options (for select)', type: 'list' },
          { key: 'sort_order', label: 'Sort order', type: 'number', default: 0 },
          { key: 'is_required', label: 'Required', type: 'checkbox' },
        ]}
        transformOut={(v) => ({ ...v, entity: 'employee' })}
      />
    </Screen>
  );
}
